////////////////////////////////////////////////////////////////////////////////
// History API
////////////////////////////////////////////////////////////////////////////////

class HistoryAPI {

	constructor() {

		this.loading = false

		this.debug = false

		this.element = false

		// Transition rules are reset after a page has loaded. These are used to
		// give in/out methods a condition to change things up.
		this.transitionRule = false

		// Set the first visit value globally
		window.firstvisit = true

		this.localHandle = document.documentElement.dataset.localeId == 1 ? '' : document.documentElement.dataset.locale

		// End Points -------------------------------------------------------------

		// If the History API is enabled and no end-points exist
		if ( isHistoryAPIEnabled === true && typeof window.history['endpoints'] === 'undefined' ) {

			// Set the preload percentage amount somewhere around 0% to 40%
			html.customProperty('loaded', Math.floor(Math.random() * 40))

			// Fetch all end-points for the site

			fetch(`/end-points?siteId=${document.documentElement.dataset.localeId || 1}`)
			.then(response => response.json())
			.then(response => {
				// console.log('History API is Ready', response)
					
				// Store all the end-points in the window's own history object
				window.history['endpoints'] = [].concat(...Object.values(response))

				// Trigger the click handle listener
				this.handler()

				// Use the current pages uri to load page content
				this.load = window.location.pathname.replace(/^\/|\/$/g, '')

				this.home = window.history.endpoints.find(entry => entry.uri == '' )

				// Set the preload percentage amount somewhere around 40% to 65%
				html.customProperty('loaded',  Math.floor(Math.random() * 25) + 40)

				// Initiate the History API pop state listener. This will
				// run the loader method each time the state changes (back or forward buttons are pressed)
				window.onpopstate = ({state}) => this.loader(state, false)
			})
			.catch(error => {
				this.loading = 'error'; console.log('error', error)
			});

		}

		/** Class Maps -------------------------------------------------------------
		* @example {
		*   Uninstantiated Class Name
		    class : News,

		*   Slug name that will be referenced to know if/when to trigger a class method
		*   This can also be an array of slugs/
		    slug : 'news',

		*   This will check to see if a class can be found in the body. This is so you can
		*   trigger the same class for mutliple pages. This can also be an array of slugs
		    selector : 'newsIntro',

		*   If a declaration exists, this will be added to the windows global scope so this class can be
		*   referenced without having to pass through a series of obscure objects
		*   This is turned 'off' by default to avoid page names potentially creating conflicts.
		    declaration : 'news',

		*   This is the method that will be called each time the page is loaded.
		    method : 'init'
		  }
		*/
		this.classmap = [
	    { class : News,    selector : '.news'},
	    { class : CaseStudies,    selector : '.case-studies'},
	    { class : History, slug : 'history'},
	    { class : Landing, slug : ['home', 'rsa', 'uae', 'our-services', 'who-we-serve', 'about-us', 'support', 'investor-relations'], selector : '.our-services.level-2.has-descendants'},
	    { class : WhereWeOperate, slug : 'where-we-operate', declaration : 'map' },
	    { class : Country, selector : '.category' },
	    { class : Services, selector : '.service' },
	    // { class : SecureLink, slug : ['vendors'] },
	    { class : Contact, slug : 'contact' }
	  ]

		// Elements that should not be removed on each new page
		this.staticElements = ['navigation-bar', 'slide-overlays', 'footer', 'introduction-wrapper', 'slide-show', 'slideshow-navigation', '#chartdiv', '#hiddenchartdiv', 'slideshow-gradient']
  }

	// ===========================================================================
  // Load handlers
	// ===========================================================================

	/**
	 * Set the loading state
	 * @param  {Boolean} bool
	 */

	set loading (bool) {

		if ( bool == 'error' ) {
			bool = false;
			document.body.classList.add('error')
			setTimeout(() => { document.body.classList.remove('error') }, 5000)
		}

		if (bool) {
			document.body.classList.add('loading')
		} else {
			document.body.classList.remove('loading')
			this.transitionRule = false
		}
		this._loading = bool
	}

	/** This is a reference for the 'this.loader' method that can be triggered
	* using this handy setter. Accepts an entry object or entry uri string
	* @example historyAPI.load = 'about/content'
	* which is the same as
	* @example historyAPI.loader('about/content')
	*/

	set load(entry) {
		this.loader(entry, true);
	}

	/**
	 * Render page content or return cached data if it exists.
	 * @param  {String|Object} entry  Entry URI, or entry data object if you have it
	 * @param  {Boolean}       update When this is true (default) the history API push state will be update too.
	 */

	loader(entry, update = true) {

		let backup = entry

		// About loading anything if something is already being loaded
		// if (this.loading) {
		// 	fetcher.abort()
		// 	console.log('Aborting')
		// 	this.loading = false;
		// }
		// if (this.loading) {
			// console.log(`Already trying to load ${this.current.title || 'a'} page. Please wait.`)
		// }

		// If the entry was a string, assume we need to query the endpoints for it.
		if ( typeof entry == 'string') {
			entry = this.find(entry);
		}

		this.current = entry;

		if ( typeof Navigation !== 'undefined' ) { Navigation.close() }

		// If the uri is part of the exception list, reload the browser.
		if ( entry && entry.hasOwnProperty('uri') && this.check.isException(entry.uri) ) {

			this.refresh(entry.uri)

		} else {

			this.loading = true;

			if ( this.debug ) { console.log(`Loading '${entry.title}' page content`) }

			// If the markup is already in the entry object, don't run another request. Use the cached data
			if ( entry && entry.hasOwnProperty('html')) {

				if ( this.debug ) { console.log(`"${entry.title}" has already been cached. No need for another fetch`) }

				entry.html = $(entry.html).find('script[src*="freeform"]').remove().end()

				this._action(entry, update)

			} else if ( entry ) {
				console.log(entry)

				fetcher.get(`/fetch-template?siteId=${document.documentElement.dataset.localeId || 1}`, entry, {
					success : (response) => {
						// Place the html markup into the entry object.
						// We'll refer to this as cache on any returns to this page
						entry['html'] = response.html
						entry['blocks'] = $(response.html)
						entry['classes'] = response.classes
						this._action(entry, update)
					},
					error : (response) => { this.loading = 'error'; console.error('error', response) }
				})

			} else {

				console.error('Entry was not found:', backup)

			}

		}

	}

	/** ==========================================================================
	* Reload the page or change location
	* ============================================================================
	* @param {String} url If you want to go to a new page, pass in a uri or full website path.
	* Passing nothing into this method will simply repload the current page.
	*/

	refresh(url) {
		if (url) {
			window.location.href = url;
		} else {
			location.reload();
		}
	}

	/** ==========================================================================
  * Action
  * ============================================================================
  * This is what happens when the entry data is obtained
  * @param {Object} entry Pass in the entry object for the page in question. This should have the 'html' property with the template mark up in it.
  * @param {Boolean} update If `true` adds a push state to the History API with the entry object as the reference data.
  */

	_action(entry, update = true) {

		if ( this.debug ) { console.log('ENTRY: ', entry) }
		
		// Update the page title
		try {
			if (entry.seo.seoTitle !== '' && !entry.seo.seoTitle.includes('seomatic.helper')) {
				document.title = entry.seo.seoTitle
			}
		} catch {
			if (document.title != entry.title) {
				document.title = (entry.uri == '' ? '' : entry.title + ' | ') + document.head.querySelector("[name=author][content]").content;
			}
		}

		if ( entry.uri.includes('careers') ) {
			Navigation.update('careers')
		} else {
			Navigation.update(entry.slug)
		}

		if($('.admin-edit').length) {
			$('.admin-edit').attr('href', entry.cpUrl || '/admin')
		}

		// Check if this page has a references in the classmap
 		let classes = this.classmap.filter(e => {

			// First check if any slugs match the entry
			if (e.hasOwnProperty('slug')) {
				let slugs = typeof e.slug == 'string' ? [e.slug] : e.slug
				for (var slug of slugs) {
					if ( slug == entry.slug ) {
						return true
					}
				}
			}

			// Also also check if a class matches the current document
			if (e.hasOwnProperty('selector')) {
				let element = document.createElement("div")
				element.className = entry.classes
				let selectors = typeof e.selector == 'string' ? [e.selector] : e.selector
				for (var selector of selectors) {
					if (element.matches(selector)) {
						return true
					}
				}
			}

		})

		classes.forEach(item => {

			// Create a classmap object on the entry if it doesn't exist
			if ( typeof entry.classmap == 'undefined' ) {
				entry.classmap = {}
			}

			let className = item.class.prototype.constructor.name

			// Make sure this classmap for this entry hasn't been constructed already
			if ( !entry.classmap.hasOwnProperty(className) ) {

				if ( this.debug ) { console.log(`Creating new "${className}" class instance for "${(entry.slug || entry.selector)}" page.`) }

				entry.classmap[className] = new item['class'](entry)

				entry.classmap[className]['element'] = this.element

				// If a declaration name was defined, create a assignment of this class
				// into the window scope. This is not always advised as it can cause conflicts.
				if(item.hasOwnProperty('declaration')){
					window[item['declaration']] = entry.classmap[className]
				}

			}

			// Trigger the init method if it eists for this pages class
			if(typeof entry.classmap[className]['init'] == "function"){
				if ( this.debug ) { console.log(`Triggering the init method found in the "${(entry.slug || entry.selector)}" in the "${className}" class.`) }
				entry.classmap[className].init(entry)
			} else {
				if ( this.debug ) { console.log(`There was no init method found in the "${(entry.slug || entry.selector)}" in the "${className}" class. So nothing will be triggered.`) }
			}

		})

		// Update the HistoryAPI state
		if ( update ) {
			this.previous = history.state !== null ? history.state : false
			if ( entry.uri == '__home__' ) {
				entry.uri = parseInt(document.documentElement.dataset.localeId, 10) == 1 ? '' : document.documentElement.dataset.locale
			}

			if ( entry && !entry.uri.replace(/^\/|\/$/g, '').startsWith(this.localHandle) ) {
				entry.uri = this.localHandle + '/' + entry.uri
			}

			// console.log('Push State: ', entry.uri, `/${entry.uri.replace(/^\/|\/$/g, '')}`)
			history.pushState(entry.uri, null, `/${entry.uri.replace(/^\/|\/$/g, '')}`)
		}

		Scroll.to(0)

		// First page visit should run the "IN" method first
		// And the introduction wrapper needs to be managed one it's finished animating.
		if ( window.firstvisit ) {

			// Set the preload percentage amount somewhere around 0% to 40%
			html.customProperty('loaded', 100)

			// Run the "in" method.
			this.in(entry)

			// Get the introduction wrapper
			let intro = document.querySelector('introduction-wrapper')

			// Listen for transition end
			intro.addEventListener('transitionend', (event) => {

				// This adds a few checks to make sure the following only runs once
				if ((event.target.nodeName.toLowerCase() == intro.nodeName.toLowerCase()) && event.propertyName == 'opacity' ) {

					// This is the only instance where 'first visit' is set to false
					window.firstvisit = false

					if ( document.documentElement.dataset.localeId &&  document.documentElement.dataset.geoLocaleId ) {

						if ( document.documentElement.dataset.localeId == "1" && document.documentElement.dataset.geoLocaleId == "8" ) {
							
							let modal = new Modal()
									
							let settings = {
								template : '_components/modals/south-africa-site.twig',
								type     : 'rsa-redirect'
							}
					
							fetcher.get('/fetch-template', settings, {
								success : (response) => {
									modal.open(response.html, (modal) => {
										let nativeCloseBtn = $(modal).find('button.close')
										let inlineCloseBtn = $(modal).find('button.stay')
										$(inlineCloseBtn).click((event)=>{
											nativeCloseBtn.trigger('click')
										})
									})
								},
								error : (response) => {
									console.log('ERROR', response);
					
								}
							})
					
					
						}
					}


					// Remove the wrapper
					intro.remove()
				}
			}, false)

		} else {

			// Any other pages should run the "out" method, passing in the entry data,
			// and the pages class instance if it exists
			this.out(entry)

		}

	}

	/** ==========================================================================
	* Page In
	* ============================================================================
	*/

	in(entry) {

		console.log('IN')

		try {

			// jQuerify the response markup
			let content = $(entry.html)
			
			// let content = entry.blocks || $(entry.html)

			// If slideshow exists, trigger the update method to manage the new slides
			// Redefine the newContent and exclude the slide-show element.
			// Simply deleting the object element causes more issues than it solves.
			if ( typeof slideshow !== 'undefined' ) {
				slideshow.update(content.filter('slide-show'))
			}
			content = content.filter(':not(slide-show)')
						
			// Change the body ID to the entry slug
			document.body.id = entry.slug

			if ( entry.uri.includes('careers') ) {
				document.body.id = 'careers'
			}

			// Remove all classes form the body
			document.body.className = this._loading ? 'loading' : ''

			// Add predetermined classes from the end-points data onto the body
			if ( entry.classes ) {
				document.body.classList.add(...entry.classes.split(' '))
			}

			// If an 'aside' element exists within the new content, add a special class to the body
			if ( Object.values(content).some(element => element.nodeName == 'SIDE-BAR' )) {
				if (entry['template'] != 'news/_entry' && entry['template'] != 'case-studies/_entry') {
					document.body.classList.add('sidebar-exists')
				}
			}

			// If the entry has any classmaps and that at least one class has an 'in' method
			if ( entry.hasOwnProperty('classmap') && Object.entries(entry.classmap).length && Object.values(entry.classmap).some(_c =>  typeof _c['in'] == "function" )) {

				// Run through each one and trigger the 'in' method for each
				Object.values(entry.classmap).forEach(_class => {

					if( typeof _class['in'] == "function" ){

						if ( this.debug ) { console.log(`Custom 'in' method for "${entry.title}"`) }

						_class.element = this.element

						_class.in(content, () => {
							this.loading = false
							if($('.admin-edit').length) {
								$('.admin-edit').attr('href', entry.cpUrl || '/admin')
							}
							if ( $('svg.button-border').length ) {
								$('svg.button-border rect').each((i, item) => {
									if ( 'getTotalLength' in item) {
										$(item).parent().customProperty('dasharray', item.getTotalLength() || 0)
									}
								})
							}
							Fixers.init()
						})
					}

				})

			} else {

				if ( entry.type == 'error' ) {
					content = content.filter('main')
				}

				if ( typeof page !== 'undefined') {

					page.in(content, () => {
						this.loading = false;
						let header = $('site-wrapper > header.invert')
						if ( header.length ) {
							$('navigation-bar').addClass('invert')
						} else {
							$('navigation-bar').removeClass('invert')
						}
						Fixers.init()

					})

				} else {

					if ( this.debug ) { console.log(`Default 'in' method for "${entry.title}"`) }
					$('site-wrapper > *:last-child').before(content)
					this.loading = false;

				}

			}

		} catch(error) {
			this.loading = false
			console.error('Error during in method', error)
		}

	}

	/** ==========================================================================
	* Page Out
	* ============================================================================
	*/

	out(entry, html) {

		try {

			// Get all first level child elements inside the site-wrapper, excluding any static element
			let content = $('site-wrapper > *' + ':not(' + this.staticElements.join('):not(') + ')')

			let previous = this.find(this.previous)

			// If the entry has a classmap
			if ( previous && typeof previous['classmap'] !== 'undefined' && Object.entries(previous.classmap).length && Object.values(previous.classmap).some(_c =>  typeof _c['out'] == "function" )) {

				// Run through each one and trigger the 'in' method for each
				Object.values(previous.classmap).forEach(_class => {

					if( typeof _class['out'] == "function" ){

						if ( this.debug ) { console.log(`Custom 'out' method for "${previous.title}"`) }

						_class['element'] = this.element

						_class.out(content, () => {
							content.remove()
							this.in(entry)
							window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
						})
					}

				})

			} else {

				if ( typeof page !== 'undefined') {

					page.out(content, () => {
						content.remove()
						this.in(entry)
						$('site-wrapper > header.invert').removeClass('invert')
						$('navigation-bar.invert').removeClass('invert')
						window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
					})

				} else {

					if ( this.debug ) { console.log(`Default 'out' method for "${this.previous ? this.previous.title : 'current page'}".`) }
					content.remove()
					this.in(entry)
					window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })

				}

			}

		} catch(error) {
			this.loading = false
			console.error('Error during out method', error)
		}

	}

	/** ==========================================================================
  * Find
  * ============================================================================
  * Search if a uri exists and return that endpoints data
  * @param {String} query The URI you want to query from the endpoints data
  * @example this.find('news')
  */

  find(query) {

		
		if ( (query == '/rsa/' || query == '/rsa' || query == 'rsa') || (query == '/uae/' || query == '/uae' || query == 'uae') ) {
			query = ''
		}

		query = query.replace(/^\/?(rsa|uae)\//, '');

		let result =  window.history.endpoints.find(entry => {
			if ( 
					entry.uri == '' && query == '' || 
					entry.uri == '' && query == '/' || 
					entry.uri == query.replace(/^\/(rsa|uae)\//, '/') ||
				  entry.uri == '' && query == document.documentElement.dataset.locale ||	
					entry.uri == '' && query == '/'+document.documentElement.dataset.locale ||
					entry.uri == '/' + query.replace(/^\/|\/$/g, '') ||
					entry.uri == query.replace(/^\/|\/$/g, '') 
			) {
				// console.table([
				// 	[entry.uri, query, (entry.uri == '' && query == '') ? '✅' : '🛑'],
				// 	[entry.uri, query, (entry.uri == '' && query == document.documentElement.dataset.locale) ? '✅' : '🛑'],
				// 	[entry.uri, query, (entry.uri == '/' +  query.replace(/^\/|\/$/g, '')) ? '✅' : '🛑']
				// ])
				return true;
			}
		})

		return result ? result : this.home

  }

	/** ==========================================================================
  * Checkers
  * ============================================================================
  * A collection of handy check methods
  */

	get check() {

		return {

			/** Checks to see if a string is a valid absolute (external) url
			* @param {String} string URL you want to check
			* @author Philipp <https://stackoverflow.com/questions/10687099/how-to-test-if-a-url-string-is-absolute-or-relative>
			* @return {Boolean}
			*/
			isAbsoluteUrl : (string) => {
		    if (string.indexOf('//') === 0) {return true}
		    if (string.indexOf('://') === -1) {return false}
		    if (string.indexOf('.') === -1) {return false}
		    if (string.indexOf('/') === -1) {return false}
		    if (string.indexOf(':') > string.indexOf('/')) {return false}
		    if (string.indexOf('://') < string.indexOf('.')) {return true}
		    return false
			},

			/** Checks to see if a string is a valid absolute (external) url
			* @param {String} string URL you want to check
			* @author Gumbo <https://stackoverflow.com/questions/6238351/fastest-way-to-detect-external-urls>
			* @return {Boolean}
			*/
			isExternalUrl : (string) => {
				let match = string.match(/^([^:\/?#]+:)?(?:\/\/([^\/?#]*))?([^?#]+)?(\?[^#]*)?(#.*)?/);
		    if (typeof match[1] === "string" && match[1].length > 0 && match[1].toLowerCase() !== location.protocol) return true;
		    if (typeof match[2] === "string" && match[2].length > 0 && match[2].replace(new RegExp(":("+{"http:":80,"https:":443}[location.protocol]+")?$"), "") !== location.host) return true;
		    return false;
			},

			/** Checks to see if the string matches the current page uri
			* @param {String} string URI you want to check
			* @return {Boolean}
			*/
			isSameUri : (string) => {
				let path = location.pathname.substr(1)
				string = string.replace(/^.*\/\/[^\/]+/, '').replace(/^\/|\/$/g, '')
				if ( string == path ) {	console.warn(`Not loading '${string == '' ? 'home' : string}', as you're already on this page.`) }
				return string == path
			},

			/** Checks to see if the string matches anything from the exceptions list
			* @param {String} string URI you want to check
			* @return {Boolean}
			*/
			isException : (string) => {
				if (typeof this.exceptions !== 'undefined') {
					string = string.replace(/^.*\/\/[^\/]+/, '').replace(/^\/|\/$/g, '')
					return this.exceptions.includes(string)
				} else {
					return false;
				}
			},

			/** Checks to see if the string is not a web page or is special protocol
			* @param {String} string URI you want to check
			* @return {Boolean}
			*/
			isSpecialLink : (string) => {

				let extensions = ['html', 'htm', 'xhtml', 'php']
				let protocols  = ['callto', 'tel', 'mailto', 'skype']

				let parser = new URL(string, location)

				let isWebFile = parser.pathname.includes('.') && !extensions.some(ext => parser.pathname.endsWith('.' + ext))
				let isSpecialProtocol = protocols.some(protocol => protocol+':' == parser.protocol)

				return isWebFile || isSpecialProtocol
			}

		}
	}

	/** ==========================================================================
  * Click handler
  * ============================================================================
  * Click events are deligated from the body and will target any 'a' or 'button' elements.
	*/

	handler() {

		let tags = ['a', 'button']

		document.body.addEventListener("click", (event) => {

				// Look for the closest allowed element tag. This is to avoid child elements
				// like SVG's or images from propagating and hijacking event target.
				if ( event.target ) {

					let target = tags.find(target => event.target.closest(target))

					if ( target ) {

						this.element = event.target.closest(target)

						let url = false

						if ( this.element.classList.contains('secure-link')) {
							event.preventDefault()
							return false;
						} else if ( this.element.hasAttribute("data-behaviour") ) {
							if ( this.element.getAttribute("data-behaviour") == 'default') {
								return false;
							} else if ( this.element.getAttribute("data-behaviour") == 'quote' && document.documentElement.dataset.locale == 'rsa') {
								event.preventDefault()
								new FreeQuote()
								return false;
							}
						}

						// Check if the element has a data-uri or href.
						if ( this.element.hasAttribute("data-uri") ) {
							url = this.element.getAttribute("data-uri")
						} else if ( this.element.hasAttribute("href") ) {
							url = this.element.getAttribute("href")
						}

						if ( url && url !== '' && !url.startsWith(this.localHandle) ) {
							url = '/' + this.localHandle + url
						}

						// If the URI exists and it's not an external url...
						if ( url !== false && !this.check.isExternalUrl(url)) {

							// If the URL is absolute but local to the current domain,
							// redefine the 'url' with just the pathname (URI)
							if (this.check.isAbsoluteUrl(url)) {
								url = new URL(url, location).pathname
							}

							// Rule out any document links, special protocols or special exceptions
							if ( !this.check.isSpecialLink(url) && !this.check.isException(url) ) {

								// Check if the page exists in any of our endpoints
								let entry = this.find(url)

								if ( entry ) {

									// Prevent this links default action
									event.preventDefault()
									event.stopPropagation()

									// So long as the page isn't currently in the middle of loading something else,
									// and we're not trying to load a page we're already on...
									if (!this.loading && !this.check.isSameUri(url)) {

										if ( this.element.hasAttribute("data-transition") ) {
											this.transitionRule = this.element.getAttribute("data-transition")
										}

										// Load the new page
										this.load = this.current = entry

									}

								} else {

								// event.preventDefault()
								// event.stopPropagation()

									// Check the status of the URL

							    let request = new XMLHttpRequest()

									// TODO: Handle the deprecation error triggered by the 'open' method.
									// [Deprecation] Synchronous XMLHttpRequest on the main thread is deprecated because of its detrimental effects to the end user's experience. For more help, check https://xhr.spec.whatwg.org/.
							    // request.open('HEAD', url, false)
									// request.send()

									// If the url links to an error page...

									if ( [400, 403, 404, 500, 503].includes(request.status) ) {

										event.preventDefault()
										event.stopPropagation()

										if ( !this.loading ) {

											// Fetch the error template
											fetcher.get(`/fetch-template`, { template : '_errors/' + request.status + '.twig', siteId : document.documentElement.dataset.localeId || 1 }, {
												success : (response) => {
													// Parse the HTML so we can query it's elements
													let parser = new DOMParser()
													let html   = parser.parseFromString(response.html, "text/html");

													// Do a few checks for the slug, as it may not exists in the template.
													let slug = () => {
														if ( html.querySelectorAll('body')[0].hasAttribute('id') ) {
															return html.querySelectorAll('body')[0].getAttribute('id')
														} else {
															return url.split('/').slice(-1)[0]
														}
													}

													// Mock up a "fake" entry so that we can transition between
													// the current page and the error page.
													let entry = {
														type  : 'error',
														html  : html.querySelectorAll('site-wrapper')[0].innerHTML,
														title : "Error " + request.status,
														slug  : slug(),
														uri   : url
													}

													// Action the entry page
													this.current = entry
													this._action(entry)

												},
												error : (response) => { this.loading = 'error'; console.error('error', response) }
											})

										}
									} else {
										console.warn(`This link appears to be relative to this domain, but an endpooint could not be found for "${url}", if it doesn't need one you'll need to add this url to the exceptions list in the HistoryAPI constructor (to invoke a page refresh). Or double check the link is correct.`)
									}

								}
							}
						}
				}
			}
		})
	}
}
